import { useOutletContext } from 'react-router-dom'
import { Subscription } from '@cel_cash/core/types'
import { Cliente, PlanoFixo } from 'service/api'

export function usePlanosContext() {
    return useOutletContext<{
        assinatura?: Subscription
        planos?: PlanoFixo[]
        cliente?: Cliente
        PlanoDiferenciado?: Cliente['PlanoDiferenciado'] | null
        isLoading: boolean
    }>()
}
